import { createStyles, makeStyles } from '@material-ui/core/styles';
import { observer } from 'mobx-react';
import { useBorrowerPortalStore } from '../../../../apps/borrower-portal-v2/src/app/hooks';
import { Button, Grid } from '@material-ui/core';
import { ConfirmationButton, createTextField, createPhoneField } from '@roc/ui';
import { Delete } from '@material-ui/icons';
import { useEffect } from 'react';
import { ReferralFormStore } from '@roc/feature-referrals';

const useStyles = makeStyles(theme => createStyles({}));

export type AddReferralProps = {
  referralFormStore: ReferralFormStore,
  referralId?: number,
  firstName?: string,
  lastName?: string
  phone?: string,
  email?: string,
};
export const AddReferral = observer(
  (props: AddReferralProps) => {
    const { referralFormStore } = props;

    useEffect(() => {
      if(props.referralId) {
        referralFormStore.loadForm(props);
      }
    }, [props.referralId]);

    return (
      <Grid item container xs={12} spacing={4}>
        <Grid item container justifyContent="center" spacing={2}>
          <Grid item xs={6}>
            {createTextField({
              store: referralFormStore,
              label: 'First Name',
              fieldName: 'firstName',
              testId: 'firstName',
            })}
          </Grid>
          <Grid item xs={6}>
            {createTextField({
              store: referralFormStore,
              label: 'Last Name',
              fieldName: 'lastName',
              testId: 'lastName',
            })}
          </Grid>
          <Grid item xs={6}>
            {createPhoneField({
              store: referralFormStore,
              label: 'Phone Number',
              fieldName: 'phone',
              testId: 'phone',
            })}
          </Grid>
          <Grid item xs={6}>
            {createTextField({
              store: referralFormStore,
              label: 'Email',
              fieldName: 'email',
              testId: 'email',
              type: 'email',
            })}
          </Grid>
          {props.referralId && (
            <Grid item xs={6}>
              <ConfirmationButton
                variant="contained"
                onClick={() =>
                  referralFormStore.deleteReferral(props.referralId)
                }
                color="primary"
                testId="deleteReferral"
                confirmDialogProps={{
                  title: 'Confirmation',
                  body: 'Are you sure you want to delete the referral?',
                }}
                startIcon={<Delete />}
              >
                Delete Referral
              </ConfirmationButton>
            </Grid>
          )}
        </Grid>
      </Grid>
    );
  }
);
